import { AiVariant } from 'modules/mel-ai';

import styles from '../content-map/content-map.module.scss';
import { VariantItemWrapper } from './variant-item-wrapper';

interface FaqsVariantMapProps {
  variants: AiVariant[];
  selectedVariantState: [AiVariant | null, React.Dispatch<React.SetStateAction<AiVariant | null>>];
}

const FaqsVariantMap = ({ selectedVariantState, variants }: FaqsVariantMapProps) => {
  return (
    <>
      {variants.map((item) => {
        const faqs = item.values;
        const parsedFaqs = Object.entries(JSON.parse(faqs as string));

        return (
          <VariantItemWrapper
            key={item.id}
            selectedVariantState={selectedVariantState}
            variant={item}
          >
            {parsedFaqs.map((item) => {
              return (
                <div key={item[0]}>
                  <div className={styles.faqQuestion}>{item[0]}</div>
                  <div className={styles.faqAnswer}>{item[1] as string}</div>
                  <br />
                  <br />
                </div>
              );
            })}
          </VariantItemWrapper>
        );
      })}
    </>
  );
};

export { FaqsVariantMap };
